const u = up.util;
up.URLPattern = class URLPattern {
    constructor(fullPattern) {
        this._groups = [];
        const positiveList = [];
        const negativeList = [];
        for (let pattern of u.getSimpleTokens(fullPattern)) {
            if (pattern[0] === '-') {
                negativeList.push(pattern.substring(1));
            }
            else {
                positiveList.push(pattern);
            }
        }
        this._positiveRegexp = this._buildRegexp(positiveList, true);
        this._negativeRegexp = this._buildRegexp(negativeList, false);
    }
    _buildRegexp(list, capture) {
        if (!list.length) {
            return;
        }
        list = u.flatMap(list, u.matchableURLPatternAtom);
        list = list.map(u.escapeRegExp);
        let reCode = list.join('|');
        reCode = reCode.replace(/\\\*/g, '.*?');
        reCode = reCode.replace(/(:|\\\$)([a-z][\w-]*)/ig, (match, type, name) => {
            if (type === '\\$') {
                if (capture) {
                    this._groups.push({ name, cast: Number });
                }
                return '(\\d+)';
            }
            else {
                if (capture) {
                    this._groups.push({ name, cast: String });
                }
                return '([^/?#]+)';
            }
        });
        return new RegExp('^(?:' + reCode + ')$');
    }
    test(url, doNormalize = true) {
        if (doNormalize) {
            url = u.matchableURL(url);
        }
        return this._positiveRegexp.test(url) && !this._isExcluded(url);
    }
    recognize(url, doNormalize = true) {
        if (doNormalize) {
            url = u.matchableURL(url);
        }
        let match = this._positiveRegexp.exec(url);
        if (match && !this._isExcluded(url)) {
            const resolution = {};
            this._groups.forEach((group, groupIndex) => {
                let value = match[groupIndex + 1];
                if (value) {
                    return resolution[group.name] = group.cast(value);
                }
            });
            return resolution;
        }
    }
    _isExcluded(url) {
        var _a;
        return (_a = this._negativeRegexp) === null || _a === void 0 ? void 0 : _a.test(url);
    }
};
